const parseContentDisposition = (
  contentDisposition: string
): string | null => {
  const utf8Match = contentDisposition.match(
    /filename\*\s*=\s*(?:UTF-8'')?["']?([^;"']+)["']?/i
  );
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1]).trim();
    } catch {
      return utf8Match[1].trim();
    }
  }

  const match = contentDisposition.match(/filename\s*=\s*"?([^";]+)"?/i);
  if (match?.[1]) return match[1].trim();

  return null;
};

const toTitleCase = (input: string): string =>
  input.replace(/\b\w/g, (c) => c.toUpperCase());

const deriveFilenameFromUrl = (url: string | undefined): string | null => {
  if (!url) return null;

  const withoutQuery = url.split("?")[0];
  const lastSegment = withoutQuery.split("/").filter(Boolean).pop();
  if (!lastSegment) return null;

  const cleaned = lastSegment
    .replace(/^get-/i, "")
    .replace(/-pdf$/i, "")
    .replace(/^policy-/i, "")
    .replace(/-form$/i, "")
    .replace(/[-_]+/g, " ")
    .trim();

  if (!cleaned) return null;
  return `${toTitleCase(cleaned)}.pdf`;
};

type AxiosLikeResponse = {
  headers?: Record<string, string | undefined> & { [key: string]: any };
  config?: { url?: string };
};

export const getFilenameFromContentDisposition = (
  source: string | undefined | null | AxiosLikeResponse,
  fallback = "downloaded.pdf"
): string => {
  if (source && typeof source === "object") {
    const headers = source.headers || {};
    const cd =
      headers["content-disposition"] ||
      headers["Content-Disposition"] ||
      (typeof headers.get === "function"
        ? headers.get("content-disposition")
        : undefined);
    if (cd) {
      const parsed = parseContentDisposition(cd);
      if (parsed) return parsed;
    }
    const fromUrl = deriveFilenameFromUrl(source.config?.url);
    if (fromUrl) return fromUrl;
    return fallback;
  }

  if (source) {
    const parsed = parseContentDisposition(source);
    if (parsed) return parsed;
  }
  return fallback;
};
